import {
  Address,
  AddressChangeRequest,
  AddressFavoriteSet,
  Brand,
  Budget,
  Item,
  Order,
  OrderSet,
  OrderVariant,
  Program,
  SubState,
  User,
} from "@models";
import { BusinessUnit } from "@models/BusinessUnit";
import { CouponType } from "@models/CouponType";
import { ItemType } from "@models/ItemType";
import { Market } from "@models/Market";
import { Offer, OfferCatalogOption } from "@models/Offer";
import { OrderCalendarMonth } from "@models/OrderCalendarMonth";
import { ProductFamily } from "@models/ProductFamily";
import { ProgramType } from "@models/ProgramType";
import { PurchaseOrder } from "@models/PurchaseOrder";
import { State } from "@models/State";
import { Supplier } from "@models/Supplier";
import { Territory } from "@models/Territory";
import { VariantAllocationHistory } from "@models/VariantAllocationHistory";

export default interface routeResourceTypes {
  "sub-states": SubState;
  markets: Market;
  brands: Brand;
  "business-units": BusinessUnit;
  budgets: Budget;
  orders: Order;
  "order-sets": OrderSet;
  "order-variants": OrderVariant;
  addresses: Address;
  "address-change-requests": AddressChangeRequest;
  "address-favorite-sets": AddressFavoriteSet;
  items: Item;
  "item-types": ItemType;
  "coupon-types": CouponType;
  offers: Offer;
  "product-sizes": OfferCatalogOption;
  "nab-items": OfferCatalogOption;
  programs: Program;
  territories: Territory;
  "variant-allocation-history": VariantAllocationHistory;
  "product-families": ProductFamily;
  "program-types": ProgramType;
  "purchase-orders": PurchaseOrder;
  states: State;
  users: User;
  "order-calendar-months": OrderCalendarMonth;
  suppliers: Supplier;
}

/** API routes that return the full collection and do not support page params */
export const RESOURCES_WITHOUT_PAGINATION = [
  "brands",
  "coupon-types",
  "item-types",
  "product-families",
  "program-types",
  "states",
  "sub-states",
  "suppliers",
  "territories",
] as const satisfies ReadonlyArray<keyof routeResourceTypes>;

const resourcesWithoutPagination = new Set<keyof routeResourceTypes>(
  RESOURCES_WITHOUT_PAGINATION
);

export function resourceImplementsPagination(
  resource: keyof routeResourceTypes
): boolean {
  return !resourcesWithoutPagination.has(resource);
}
